<template>
  <div class="sales-leave-table" :class="{ 'sales-leave-table--grouped': grouped }">
    <app-data-table design="new" :columns="columns" :rows="items" :loading="loading" :density="workspace ? 'dense' : 'compact'" row-key="id" :min-width="workspace ? '1200px' : '800px'">
      <template #cell-employee="{ row }">
        <app-table-user v-if="workspace" :name="row.employee.full_name" :photo="row.employee.photo || ''"><router-link class="ui-link" :to="{ name: 'employees-profile', params: { id: row.employee.id } }">{{ row.employee.full_name }}</router-link></app-table-user>
        <router-link v-else-if="showEmployee" class="sales-leave-table__employee" :to="{ name: 'employees-profile', params: { id: row.employee.id } }">{{ row.employee.full_name }}</router-link>
        <strong v-else>{{ row.employee.full_name }}</strong>
      </template>
      <template #cell-type="{ row }">{{ row.type.name }}</template>
      <template #cell-period="{ row }"><app-table-text v-if="workspace" :text="formatPeriod(row.from_date, row.to_date)" /><template v-else>{{ formatPeriod(row.from_date, row.to_date) }}</template></template>
      <template #cell-days="{ row }">{{ row.days }}</template>
      <template #cell-status="{ row }">
        <app-status-badge design="new" compact :label="row.period_status.name" :tone="periodTone(row)" />
        <app-status-badge v-if="row.change_pending" design="new" compact label="Change pending" tone="amber" />
      </template>
      <template #cell-description="{ row }"><app-table-text v-if="workspace" :text="row.description" /><template v-else>{{ row.description || '—' }}</template></template>
      <template #cell-actions="{ row }">
        <div v-if="workspace" class="ui-actions ui-actions--tight">
          <app-icon-button v-if="canChange(row)" label="Request date change" tone="amber" @click="$emit('change', row)"><i class="pi pi-calendar" aria-hidden="true" /></app-icon-button>
          <app-icon-button v-if="!row.change_pending && row.period_status.code !== 'cancelled' && row.from_date > businessToday()" label="Request cancellation" tone="red" @click="$emit('cancel-leave', row)"><i class="pi pi-ban" aria-hidden="true" /></app-icon-button>
          <app-icon-button v-if="row.change_pending" label="View request" @click="$emit('open-request', row.pending_change_request_id)"><i class="pi pi-eye" aria-hidden="true" /></app-icon-button>
        </div>
        <div v-else class="sales-leave-table__actions">
          <app-button v-if="canChange(row)" design="new" theme="info" size="small" @click.native="$emit('change', row)">Request date change</app-button>
          <app-button v-if="!row.change_pending && row.period_status.code !== 'cancelled' && row.from_date > businessToday()" design="new" size="small" @click.native="$emit('cancel-leave', row)">Request cancellation</app-button>
          <a v-if="row.change_pending" href="#" @click.prevent="$emit('open-request', row.pending_change_request_id)">View request</a>
        </div>
      </template>
      <template #empty>
        <app-no-results design="new" small title="No leaves" text="Approved leaves will appear here." :margin-top="0" :margin-bottom="0" />
      </template>
    </app-data-table>
  </div>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import AppTableUser from '@/components/AppTableUser.vue'
import { businessToday } from './salesLeave'
import { formatPeriod } from './format'

export default {
  components: { AppTableText, AppTableUser },
  name: 'SalesLeaveLeavesTable',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    showEmployee: {
      type: Boolean,
      default: false
    },
    grouped: {
      type: Boolean,
      default: false
    },
    workspace: Boolean,
    loading: Boolean
  },
  computed: {
    columns() {
      return [
        ...(this.showEmployee ? [{ key: 'employee', label: 'Employee', minWidth: '150px' }] : []),
        ...(!this.grouped ? [{ key: 'type', label: 'Type', minWidth: '130px' }] : []),
        { key: 'period', label: 'Current dates', minWidth: '170px' },
        { key: 'days', label: 'Days', align: 'right', width: '55px' },
        { key: 'status', label: 'Status', minWidth: '125px' },
        { key: 'description', label: 'Description', minWidth: '160px' },
        { key: 'actions', label: 'Actions', minWidth: '180px' }
      ]
    }
  },
  methods: {
    formatPeriod,
    businessToday,
    periodTone(row) {
      return {
        active: 'green',
        completed: 'green',
        upcoming: 'blue'
      }[row.period_status.code] || 'neutral'
    },
    canChange: row => row.period_status.code !== 'cancelled' && !row.change_pending && row.to_date >= businessToday()
  }
}
</script>

<style lang="scss" scoped>
@import './salesLeaveTable';
</style>
